import _regeneratorRuntime from "/builds/i7wYx6jd/0/engineering/growth/pricing-calculator/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";

var _marked =
/*#__PURE__*/
_regeneratorRuntime.mark(numbers);

export default function (x) {
  return x === null ? NaN : +x;
}
export function numbers(values, valueof) {
  var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, value, index, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _value;

  return _regeneratorRuntime.wrap(function numbers$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (!(valueof === undefined)) {
            _context.next = 30;
            break;
          }

          _iteratorNormalCompletion = true;
          _didIteratorError = false;
          _iteratorError = undefined;
          _context.prev = 4;
          _iterator = values[Symbol.iterator]();

        case 6:
          if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
            _context.next = 14;
            break;
          }

          value = _step.value;

          if (!(value != null && (value = +value) >= value)) {
            _context.next = 11;
            break;
          }

          _context.next = 11;
          return value;

        case 11:
          _iteratorNormalCompletion = true;
          _context.next = 6;
          break;

        case 14:
          _context.next = 20;
          break;

        case 16:
          _context.prev = 16;
          _context.t0 = _context["catch"](4);
          _didIteratorError = true;
          _iteratorError = _context.t0;

        case 20:
          _context.prev = 20;
          _context.prev = 21;

          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }

        case 23:
          _context.prev = 23;

          if (!_didIteratorError) {
            _context.next = 26;
            break;
          }

          throw _iteratorError;

        case 26:
          return _context.finish(23);

        case 27:
          return _context.finish(20);

        case 28:
          _context.next = 58;
          break;

        case 30:
          index = -1;
          _iteratorNormalCompletion2 = true;
          _didIteratorError2 = false;
          _iteratorError2 = undefined;
          _context.prev = 34;
          _iterator2 = values[Symbol.iterator]();

        case 36:
          if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
            _context.next = 44;
            break;
          }

          _value = _step2.value;

          if (!((_value = valueof(_value, ++index, values)) != null && (_value = +_value) >= _value)) {
            _context.next = 41;
            break;
          }

          _context.next = 41;
          return _value;

        case 41:
          _iteratorNormalCompletion2 = true;
          _context.next = 36;
          break;

        case 44:
          _context.next = 50;
          break;

        case 46:
          _context.prev = 46;
          _context.t1 = _context["catch"](34);
          _didIteratorError2 = true;
          _iteratorError2 = _context.t1;

        case 50:
          _context.prev = 50;
          _context.prev = 51;

          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }

        case 53:
          _context.prev = 53;

          if (!_didIteratorError2) {
            _context.next = 56;
            break;
          }

          throw _iteratorError2;

        case 56:
          return _context.finish(53);

        case 57:
          return _context.finish(50);

        case 58:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[4, 16, 20, 28], [21,, 23, 27], [34, 46, 50, 58], [51,, 53, 57]]);
}